import classNames from 'classnames';

type DividerProps = {
  className?: string;
  vertical?: boolean;
};

const Divider = ({ className, vertical }: DividerProps) => {
  const Tag = vertical ? 'span' : 'hr';

  return (
    <Tag
      className={classNames(
        'border-neutral-50',
        {
          'border-t': !vertical,
          'border-l': vertical,
        },
        className,
      )}
    />
  );
};

export default Divider;
